import { memoize } from "@knyt/artisan";
/**
 * Creates a selector by combining multiple selectors with a combiner function.
 *
 * The resulting selector is memoized and will only recompute when the input selectors' results change.
 *
 * @public
 */
export function createSelector(...selectors) {
    return {
        // The default `maxCacheSize` is set to `1`, caching only the most recent result.
        // Since selectors are generally invoked with the same state object reference,
        // increasing the cache size is rarely needed. Explicitly setting it to `1` here
        // ensures predictable behavior, regardless of the default in `memoize`.
        combine(combiner, maxCacheSize = 1) {
            const memoizedCombiner = memoize(combiner, maxCacheSize);
            return (state) => {
                const combinerArgs = selectors.map((selector) => selector(state));
                return memoizedCombiner(...combinerArgs);
            };
        },
    };
}
